import React, { useState } from 'react'
import styled from 'styled-components'
import './style.css'
import { ResourceData } from './resources.data'
import { TableHeader } from '../../../../components/tableheader'
import { TableData } from '../../../../components/tabledata'

import { Button } from '../../../../components/button'

const Collections = () => {
    const [addResource, setAddResource] = useState(false)

    const handleAddResource = (e) => {
        setAddResource(!addResource)

    }

  return (
    <Container className='body_cont'>
      
      <PageHeader>
        <h2>My Collections</h2>
        
        <div className='search_bar'>
          <input type="text" name='collectionSearch' id='collectionSearch'  placeholder='Search items' />
          <div onClick={handleAddResource} >
            <Button filled bgColor={'#2A870E'} text={' + Add'} noIcon reverse />
          </div>
          
        </div>
      </PageHeader>

{addResource ?
      <AddResource>

        <form> 

        <MainForm>
            <div>
              <label htmlFor="tag">Collection ID</label>
              <input type="text" name='collectionID' id='collectionID' placeholder='Enter collection ID' />
            </div>

            <div>
              <label htmlFor="category">Collection name</label>
              <input type="text" name='collectionName' id='collectionName' placeholder='Enter collection ID' />
            </div>  
        {/* </DividedInput> */}


        
        </MainForm>

        <div className='publish'>
          <Button filled bgColor={'#2A870E'} text={'Publish'} noIcon reverse />
        </div>
        
        </form>
        
      </AddResource>
:
null
}

      <section>
        <TableHeader newpaperName={'Collection name'} authorName={'Collection ID'} />
         

{
              ResourceData.map((resources) => {
                return (
                  <TableData resourceTitle={resources.resourceTitle.substring(0, 50) + '...'} 
                  authorName={resources.authorName.substring(0, 50) + '...'}  
                  />
                  
                  
                )
              })
        
}      

</section>

      

      
    </Container>
  )
}

const Container = styled.section`
  padding-top: 40px;
  padding-left: 30px;
  padding-right: 30px;
  width: 100%;
`

const PageHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  & > div{
    display: flex;
    height: 40px;

    & > input{
      /* outline: none; */
      padding: 1rem;
      background-color: inherit;
      border-radius: 4px;
      border: 1px solid #D0D5DD;
    }

    & button{
      padding: 1rem;
      margin-left: 1rem;
      /* width: 50px; */
    }
  }
`

const AddResource = styled.div`
  padding: 0px 25px 0;
  border: 1px solid #D0D5DD;
  margin-top: 30px;
  margin-bottom: 30px;

  & form {


    & > :last-child{
      margin-top: 3rem;
      border-top: 1px solid #D0D5DD;
      align-self: flex-end;
      padding: 1rem 0;
    }
    & button{
      padding: 1rem;
      margin-left: 1rem;
      align-self: flex-end;
      /* margin-top: 3rem; */

      /* border: 1px solid red; */

      /* width: 50px; */
    }
  }
`



const MainForm = styled.div`


  & > div{

    display: flex;
    flex-direction: column;

    & > input{
      background-color: inherit;
      height: 44px;
      padding: 1rem;
      border-radius: 4px;
      border: 1px solid #D0D5DD;
      
  }

    & > label{
      font-size: 14px;
      font-weight: 500;
      margin-top: 25px;
      margin-bottom: 0.8rem;
      /* color: #667085; */
    }

    & > textarea{
      height: 10rem;
      padding: 1rem;
      border-radius: 4px;
      border: 1px solid #D0D5DD;
      background-color: #fff;

    }

    
  }
`

const DividedInput = styled.section`
 

  & > div{
    display: flex;
    flex-direction: column;
    

    

  &  label{
      font-size: 14px;
      font-weight: 500;
      margin-top: 10px;
      margin-bottom: 5px;

    }

  }
`

export {Collections}